import { useQuery } from "@apollo/client/react";

import LinkButton from "ds/components/Button/LinkButton";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import useTypedContext from "hooks/useTypedContext";
import { getBurstVerdict } from "shared/Usage/utils";
import { AccountContext } from "views/AccountWrapper";

import { BURST_CALLOUT_CONTENT, USAGE_WORKERS_PATH } from "./constants";
import { GET_WORKER_USAGE_BURST } from "./gql";

const BurstBudgetCallout = () => {
  const { viewer } = useTypedContext(AccountContext);

  const { data } = useQuery(GET_WORKER_USAGE_BURST, {
    skip: !viewer.admin,
    fetchPolicy: "no-cache",
    context: { suppressFlashError: true },
  });

  const usage = data?.workerUsage;

  if (!usage?.burst || usage.multiAccountContract) {
    return null;
  }

  const verdict = getBurstVerdict(usage.burst);

  if (verdict !== "approaching" && verdict !== "over") {
    return null;
  }

  const { variant, storageKeyPrefix, getTitle, body } = BURST_CALLOUT_CONTENT[verdict];
  const { start, end } = usage.cycle;

  return (
    <Callout
      variant={variant}
      title={getTitle(usage.burst)}
      storageKey={`${storageKeyPrefix}:${start}:${end}`}
    >
      {body}
      <FeedbackActions>
        <LinkButton variant="contrast" size="small" to={USAGE_WORKERS_PATH}>
          See usage
        </LinkButton>
      </FeedbackActions>
    </Callout>
  );
};

export default BurstBudgetCallout;
